import { api } from '../../utils/api';

export type OptimizeProductTitleLang = {
  lang: string;
  name: string;
  language: string;
};

export type OptimizeProductTitleInput = {
  initialTitle: string;
  initialLang: OptimizeProductTitleLang;
  maxLength: number | null;
  targetLangs: OptimizeProductTitleLang[];
};

export type OptimizedProductTitle = {
  lang: string;
  title: string;
};

export async function optimizeProductTitle(
  input: OptimizeProductTitleInput,
): Promise<OptimizedProductTitle[]> {
  const response = await api.post('/openai/optimize-product-title', input);
  const data = await response.json();
  if (!Array.isArray(data?.titles)) {
    throw new Error('Invalid optimize title response');
  }
  return data.titles.flatMap((item: { lang?: unknown; title?: unknown }) => {
    if (typeof item?.lang !== 'string' || typeof item?.title !== 'string') return [];
    const title = item.title.trim();
    if (!title) return [];
    return [{ lang: item.lang.toUpperCase(), title }];
  });
}
